<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>TypeScript Client Annotations</h1>
					<p waBody="m" waText>Annotation library for describing Angular metadata in Java &mdash; &#64;NgComponent, &#64;NgDataService, &#64;NgDirective, &#64;NgRoutable, &#64;NgField, &#64;NgSignal, lifecycle hooks, import management, and boot-module configuration. The generator produces ready-to-compile .ts files, Angular modules, routing configs, and STOMP-backed event-bus services.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Maven 4</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:typescript-client</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.core.base.angular.client</p>
					<p waBody="s" waText>Built on: Angular / TypeScript 20 / 5</p>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>INSTALLATION</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
						<markdown [data]="mdContent_119" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="code-block-wrapper">
						<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
						<markdown [data]="mdContent_120" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>FEATURES</div>
					<p waBody="s" waColorText="quiet" waText>Ng&#42; annotation family &mdash; &#64;NgApp, &#64;NgComponent, &#64;NgModule, &#64;NgDirective, &#64;NgDataService, &#64;NgDataType, &#64;NgServiceProvider, &#64;NgProvider, &#64;NgValidator, &#64;NgSchema</p>
					<p waBody="s" waColorText="quiet" waText>Component metadata &mdash; &#64;NgInput, &#64;NgOutput, &#64;NgComponentTagAttribute for Angular I/O</p>
					<p waBody="s" waColorText="quiet" waText>Lifecycle hooks &mdash; &#64;NgOnInit, &#64;NgOnDestroy, &#64;NgAfterViewInit, &#64;NgAfterViewChecked, &#64;NgAfterContentInit</p>
					<p waBody="s" waColorText="quiet" waText>Structural code generation &mdash; &#64;NgField, &#64;NgMethod, &#64;NgConstructorParameter, &#64;NgConstructorBody, &#64;NgInterface, &#64;NgSignal, &#64;NgSignalComputed, &#64;NgSignalEffect</p>
					<p waBody="s" waColorText="quiet" waText>Import management &mdash; &#64;NgImportReference, &#64;NgImportModule, &#64;NgImportProvider, &#64;NgComponentReference</p>
					<p waBody="s" waColorText="quiet" waText>Global annotations &mdash; &#64;NgGlobalField, &#64;NgGlobalConstructorParameter for cross-cutting concerns</p>
					<p waBody="s" waColorText="quiet" waText>Routing &mdash; &#64;NgRoutable &#40;path, redirectTo, pathMatch, parent, sortOrder&#41; and &#64;NgRouteData</p>
					<p waBody="s" waColorText="quiet" waText>Boot-module annotations &mdash; &#64;NgBootDeclaration, &#64;NgBootModuleImport, &#64;NgBootImportReference, &#64;NgBootEntryComponent</p>
					<p waBody="s" waColorText="quiet" waText>Angular CLI config &mdash; &#64;NgAsset, &#64;NgScript, &#64;NgStyleSheet, &#64;NgPolyfill for angular.json integration</p>
					<p waBody="s" waColorText="quiet" waText>TypeScript dependencies &mdash; &#64;TsDependency, &#64;TsDevDependency, &#64;NgSourceDirectoryReference</p>
					<p waBody="s" waColorText="quiet" waText>Built-in EventBusService &mdash; STOMP over WebSocket with auto-reconnect and RxJS observables</p>
					<p waBody="s" waColorText="quiet" waText>Java to TypeScript field mapping &mdash; introspects generics, enums, dates, optionals with jakarta.validation awareness</p>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<div waCaption="s" waFontWeight="semibold" waText>EXAMPLES</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Component with Fields and Lifecycle</h4>
						<p waBody="s" waColorText="quiet" waText>Define an Angular component with typed fields and lifecycle hooks.</p>
						<markdown [data]="mdContent_121" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>Routing with Route Data</h4>
						<p waBody="s" waColorText="quiet" waText>Define a routable page with route metadata.</p>
						<markdown [data]="mdContent_122" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>QUICK START</div>
					<markdown [data]="mdContent_123" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-s">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINT DETAILS</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">IGuiceModule</wa-tag>
							<wa-tag pill variant="neutral">provides</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Registers TypeScript client Guice bindings for annotation processing</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">OnGetAllFields</wa-tag>
							<wa-tag pill variant="neutral">uses</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Extension point for custom field generation in TypeScript output</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">OnGetAllMethods</wa-tag>
							<wa-tag pill variant="neutral">uses</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Extension point for custom method generation in TypeScript output</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">OnGetAllImports</wa-tag>
							<wa-tag pill variant="neutral">uses</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Extension point for custom import generation in TypeScript output</p>
					</div>
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">OnGetAllConstructorParameters</wa-tag>
							<wa-tag pill variant="neutral">uses</wa-tag>
						</div>
						<p waBody="s" waColorText="quiet" waText>Extension point for constructor parameter injection in TypeScript output</p>
					</div>
				</div>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>SPI EXTENSION POINTS</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="success">provides IGuiceScanModuleInclusions</wa-tag>
						<wa-tag pill variant="success">provides IGuiceModule</wa-tag>
						<wa-tag pill variant="success">provides IGuiceConfigurator</wa-tag>
						<wa-tag pill variant="success">provides IGuicePostStartup</wa-tag>
					</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="brand">uses OnGetAllConstructorParameters</wa-tag>
						<wa-tag pill variant="brand">uses OnGetAllConstructorBodies</wa-tag>
						<wa-tag pill variant="brand">uses OnGetAllFields</wa-tag>
						<wa-tag pill variant="brand">uses OnGetAllImports</wa-tag>
						<wa-tag pill variant="brand">uses OnGetAllMethods</wa-tag>
						<wa-tag pill variant="brand">uses OnGetAllModuleImports</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>PREREQUISITES</div>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://angular.dev/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/TypescriptClient</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>